import { useBasket } from '../state/BasketContext'
import { useTranslation } from '../i18n/LanguageContext'
import type { UserProfile, Sex, ActivityLevel } from '../types'

const ACTIVITY_LEVELS: ActivityLevel[] = ['sedentary', 'light', 'moderate', 'active', 'veryActive']

export function ProfileEditor() {
  const { userProfile, setUserProfile } = useBasket()
  const { t } = useTranslation()

  const update = (patch: Partial<UserProfile>) => {
    setUserProfile({ ...userProfile, ...patch })
  }

  return (
    <div className="d-none d-lg-flex align-items-center gap-3 mt-2 flex-wrap">
      <div className="d-flex align-items-center gap-1">
        <label className="text-muted small mb-0">{t('profile.age')}</label>
        <input
          type="number"
          className="form-control form-control-sm"
          value={userProfile.age}
          min={21}
          max={120}
          onChange={e => update({ age: parseInt(e.target.value) || 21 })}
          style={{ width: '65px' }}
        />
      </div>
      <span className="text-muted opacity-25">|</span>
      <div className="d-flex align-items-center gap-1">
        <label className="text-muted small mb-0">{t('profile.sex')}</label>
        <select
          className="form-select form-select-sm"
          value={userProfile.sex}
          onChange={e => update({ sex: e.target.value as Sex })}
          style={{ width: '85px' }}
        >
          <option value="male">{t('profile.sex.male')}</option>
          <option value="female">{t('profile.sex.female')}</option>
        </select>
      </div>
      <span className="text-muted opacity-25">|</span>
      <div className="d-flex align-items-center gap-1">
        <label className="text-muted small mb-0">{t('profile.weight')}</label>
        <input
          type="number"
          className="form-control form-control-sm"
          value={userProfile.weightKg}
          min={20}
          max={300}
          onChange={e => update({ weightKg: parseFloat(e.target.value) || 20 })}
          style={{ width: '70px' }}
        />
        <span className="text-muted small">{t('profile.unitKg')}</span>
      </div>
      <span className="text-muted opacity-25">|</span>
      <div className="d-flex align-items-center gap-1">
        <label className="text-muted small mb-0">{t('profile.height')}</label>
        <input
          type="number"
          className="form-control form-control-sm"
          value={userProfile.heightCm}
          min={100}
          max={250}
          onChange={e => update({ heightCm: parseFloat(e.target.value) || 100 })}
          style={{ width: '70px' }}
        />
        <span className="text-muted small">{t('profile.unitCm')}</span>
      </div>
      <span className="text-muted opacity-25">|</span>
      <div className="d-flex align-items-center gap-1">
        <label className="text-muted small mb-0">{t('profile.activity')}</label>
        <select
          className="form-select form-select-sm"
          value={userProfile.activityLevel}
          onChange={e => update({ activityLevel: e.target.value as ActivityLevel })}
          style={{ width: 'auto' }}
        >
          {ACTIVITY_LEVELS.map(level => (
            <option key={level} value={level}>{t(`profile.activity.${level}`)}</option>
          ))}
        </select>
      </div>
    </div>
  )
}
